import { atom } from 'recoil';

export const disableForEnterpriseAtom = atom({
  key: 'disableForEnterprise', 
  default: false,       
});